(function () {
  var VARIANT = '44587139006551';

  /* ---- buy buttons ---- */
  [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
    a.setAttribute('href', '/cart/' + VARIANT + ':1');
    a.removeAttribute('target');
  });

  /* ---- accordions (shipping / guarantee / how to use / FAQ) ---- */
  [].slice.call(document.querySelectorAll('[data-wld-role="accordion-row"]')).forEach(function (row) {
    row.style.cursor = 'pointer';
    row.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.wld-answer')) return;
      var open = row.hasAttribute('data-house-open');
      if (open) row.removeAttribute('data-house-open'); else row.setAttribute('data-house-open', '');
      var ic = row.querySelector('.png-faq-icon');
      if (ic) ic.textContent = open ? '+' : String.fromCharCode(8722);
    });
  });

  /* ---- product gallery: thumbnails switch the main photo ---- */
  (function () {
    var main = document.querySelector('.png-hero-main-image');
    var thumbs = [].slice.call(document.querySelectorAll('.png-hero-thumb'));
    if (!main || !thumbs.length) return;
    function show(i) {
      main.style.setProperty('background-image', getComputedStyle(thumbs[i]).backgroundImage, 'important');
      thumbs.forEach(function (t, k) { t.classList.toggle('png-hero-thumb-active', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    show(0);
  })();

  /* ---- footer: use the store's homepage footer (isolated frame, no scripts / tracking) ---- */
  (function () {
    var anchor = document.querySelector('.png-root');
    if (!anchor) return;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var all = [].slice.call(doc.querySelectorAll('.shopify-section-group-footer-group'));
      if (!all.length) return;
      var grp = doc.createElement('div');
      grp.className = 'tb-footer-wrap';
      [].slice.call(doc.querySelectorAll('script,noscript,iframe')).forEach(function (e) { e.parentNode.removeChild(e); });
      var base = doc.createElement('base');
      base.setAttribute('href', location.origin + '/');
      base.setAttribute('target', '_top');
      doc.head.insertBefore(base, doc.head.firstChild);
      var stl = doc.createElement('style');
      stl.textContent = 'html,body{margin:0 !important;padding:0 !important;overflow:hidden !important}';
      doc.head.appendChild(stl);
      doc.body.innerHTML = '';
      all.forEach(function (e) { grp.appendChild(e); });
      doc.body.appendChild(grp);
      var frame = document.createElement('iframe');
      frame.setAttribute('title', 'Footer');
      frame.setAttribute('scrolling', 'no');
      frame.style.cssText = 'display:block;width:100%;border:0;height:300px';
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      function fit() {
        try {
          var g = frame.contentDocument.querySelector('.tb-footer-wrap');
          if (g) frame.style.height = Math.ceil(g.getBoundingClientRect().height) + 'px';
        } catch (e) {}
      }
      frame.addEventListener('load', function () {
        fit();
        try { new ResizeObserver(fit).observe(frame.contentDocument.querySelector('.tb-footer-wrap')); } catch (e) {}
        setTimeout(fit, 400); setTimeout(fit, 1500);
      });
      window.addEventListener('resize', fit);
      anchor.parentNode.insertBefore(frame, anchor.nextSibling);
    }).catch(function () {});
  })();
})();
